import { get, put } from "../utils/request";

export const getServiceEntry = (teamId) => {
  return get(`/v1/teams/${teamId}/service-entries`);
}

export const getServiceDetail = (serviceId) => {
  return get(`/v1/service-entries/${serviceId}`);
}

export const updateServicePrivacy = (serviceId, body) => {
  return put(`/v1/service-entries/${serviceId}/update-privacy`, body);
}

export const getTeams = () => {
  return get('/v1/teams')
}

export const updateServicePublicDomain = (serviceId, body) => {
  return put(`/v1/service-entries/${serviceId}`, body);
}